<mat-form-field class="w-100" [color]="color" [floatLabel]="hasFloatingLabel ? 'always' : 'auto'">
    @if (!!label) {
        <mat-label>{{ isLabelTranslated ? label : (label | translate) }}</mat-label>
    }
    <!-- in multi-select the chip grid is the form field control, so the label stays floating while chips exist -->
    @if (isMultiSelect()) {
        <mat-chip-grid #chipGrid [disabled]="disabled()">
            @for (item of selectedItems(); track item.id) {
                <mat-chip-row (removed)="unselectItem(item)">
                    {{ displayFn(item) }}
                    <button matChipRemove>
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip-row>
            }
            <input
                #trigger="matAutocompleteTrigger"
                type="text"
                [matChipInputFor]="chipGrid"
                [ngModel]="currentValue()"
                (ngModelChange)="onInputChange($event)"
                [matAutocomplete]="autoComplete"
                (blur)="onBlur(trigger.panelOpen)"
                [disabled]="disabled()" />
        </mat-chip-grid>
    } @else {
        <input
            #trigger="matAutocompleteTrigger"
            matInput
            type="text"
            [ngModel]="currentValue()"
            (ngModelChange)="onInputChange($event)"
            [matAutocomplete]="autoComplete"
            (blur)="onBlur(trigger.panelOpen)"
            [disabled]="disabled()" />
    }
    <mat-autocomplete
        autoActiveFirstOption
        #autoComplete="matAutocomplete"
        (optionSelected)="onOptionSelected($event)"
        (closed)="onPanelClosed()"
        [displayWith]="displayCurrentValue">
        @if (isSearching()) {
            <mat-option [value]="undefined" disabled>
                <mat-spinner [diameter]="24" class="m-auto" />
            </mat-option>
        } @else {
            @for (item of filteredItems(); track item.id) {
                <mat-option [value]="item" [id]="item.id" [disabled]="disabled()" [class.multi-select-option]="isMultiSelect()">
                    @if (isMultiSelect()) {
                        <!-- handles the click itself so mat-option doesn't select and close the panel -->
                        <div
                            class="multi-select-option-content"
                            (mousedown)="$event.preventDefault()"
                            (click)="$event.stopPropagation(); toggleItem(item)">
                            <mat-checkbox [checked]="isItemSelected(item)" disabled />
                            <span>{{ displayFn(item) }}</span>
                        </div>
                    } @else {
                        {{ displayFn(item) }}
                    }
                </mat-option>
            }
        }
    </mat-autocomplete>
    @if (isLoading()) {
        <mat-spinner matSuffix [diameter]="24" />
    }
    @if (_formControl) {
        <mat-error>
            <sl-form-field-error-control [control]="_formControl" />
        </mat-error>
    }
</mat-form-field>
